module.exports = __webpack_public_path__ + "assets/trigger_payment_failed.96d04532.svg";